import React from 'react';
import Spinner from 'react-spinkit';

const Loader = () => (
  <div className="c-heading u-p++ u-text-center">
    Loading
    <Spinner className="u-co-teal-blue" noFadeIn />
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/app/components/Loader.jsx